import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

import { clearAdminSession } from '../utils/accountAccess';
import { hasUsableAdminToken, revalidateAdminSession } from '../utils/adminSession';

export default function RequireAuth() {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const usable = hasUsableAdminToken(token);
  const [state, setState] = useState({ token: null, status: 'checking' });

  useEffect(() => {
    if (!usable) {
      if (token) clearAdminSession();
      return undefined;
    }
    let active = true;
    revalidateAdminSession(token).then((result) => {
      if (!active) return;
      if (result.status === 'ended') {
        if (localStorage.getItem('token') === token) clearAdminSession();
        setState({ token, status: 'ended' });
        return;
      }
      if (result.status === 'valid' && result.user) {
        localStorage.setItem('user', JSON.stringify(result.user));
      }
      setState({ token, status: 'ready' });
    });
    return () => {
      active = false;
    };
  }, [token, usable]);

  const status = state.token === token ? state.status : 'checking';
  if (!usable || status === 'ended') {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  if (status === 'checking') {
    return (
      <Box role="status" aria-live="polite" sx={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }}>
        <Box sx={{ display: 'grid', placeItems: 'center', gap: 2 }}>
          <CircularProgress />
          <Typography>Verificando sua sessão...</Typography>
        </Box>
      </Box>
    );
  }
  return <Outlet />;
}
